import React from 'react';
import { useSelector } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import createHistory from 'history/createMemoryHistory';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { ContainedHeader } from 'web-ui-components/lib/layout/headers';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import Routes from './routes';
import { Loader } from '../infrastructure/loader';
import { UtilityNavigation } from '../components/UtilityNavigation/UtilityNavigation';
import { content } from '../infrastructure/content/selectors';

export const history = createHistory();

const App = () => {
  const { externalContent } = useSelector((state) => ({
    externalContent: content(state)
  }));
  const { defaultBusinessHeader, defaultBankLabel, defaultBusinessAccountLabel } = externalContent;
  return (
    <ConnectedRouter history={history}>
      <ApplicationFormShell
        header={
          <ContainedHeader
            subline={[
              defaultBusinessHeader,
              <Identifier.NonWrapping>{defaultBankLabel}</Identifier.NonWrapping>,
              <Identifier.NonWrapping>{defaultBusinessAccountLabel}</Identifier.NonWrapping>
            ]}
          />
        }
        utilityNavigation={<UtilityNavigation history={history} />}
      >
        <Loader />
        <Routes history={history} />
      </ApplicationFormShell>
    </ConnectedRouter>
  );
};
export default App;
